import Vue from 'vue';
import axios from 'axios';
import get from '../../node_modules/lodash/get';

class Api {
  async init(config) {
    this.updateConfig(config);
    this.httpClient = await axios.create({
      baseURL: this.serverUrl,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
    this.initHttpClientInterceptors();
  }

  initHttpClientInterceptors() {
    this.httpClient.interceptors.response.use(null, async (error) => {
      if (
        get(error, 'config.headers.Authorization')
        && [401].includes(get(error, 'response.status'))
        && !['WarpwireAuthorizationError'].includes(get(error, 'response.data.name'))
      ) {
        this.refreshCounter += 1;
        if (this.refreshCounter >= 4) return Promise.reject('Unable to refresh the PlayPosit token associated with your account.');
        try {
          await this.refreshToken();
          return axios.request(error.config);
        } catch(e) {
          return Promise.reject(e);
        }
      }
      return Promise.reject({
        ...get(error, 'response.data', {}),
        message: (() => {
          if (get(error, 'response.data.message')) return error.response.data.message;
          if (get(error, 'response.data.msg')) return error.response.data.msg;
          if (get(error, 'response.data.statusText')) return error.response.data.statusText;
          if (get(error, 'message')) return error.message;
          if (get(error, 'msg')) return error.msg;
          if (get(error, 'statusText')) return error.statusText;
          return 'An unknown error has occurred.';
        })(),
        status: get(error, 'response.status', get(error, 'status')),
      });
    });
  }

  addFeedback(
    feedback,
    interactionAttemptId,
    sectionId
  ) {
    return this.httpClient.post('instructor/feedback', {
      feedback,
      interactionAttemptId,
      sectionId,
    });
  }

  getServerUrl() {
    return this.serverUrl;
  }

  getToken() {
    return this.token;
  }

  refreshToken() {
    return this.httpClient.post('authnew/refreshtoken', {
      old_token: this.token,
    });
  }

  uploadAudio(formData) {
    return this.httpClient.post('upload/audio', formData);
  }

  uploadImage(formData) {
    return this.httpClient.post('upload/image', formData);
  }

  updateConfig(config) {
    for (const key in config) {
      if ([
        'serverUrl',
        'token',
        'bulbId',
        'interactionId',
        'sectionId',
        'studentId',
      ].includes(key)) this[key] = config[key];
    }
  }
}
const api = new Api();
if (!Vue.prototype.$tinymceApi) Object.defineProperty(Vue.prototype, '$tinymceApi', { value: api });
export default api;